import React, { Fragment, useEffect, useState } from 'react';
import paginationFactory from 'react-bootstrap-table2-paginator';
import BootstrapTable from 'react-bootstrap-table-next';
import format from 'date-fns/format';

import { Button, PopoverBody, UncontrolledPopover } from 'reactstrap';
import { UrlEnum, useToastState, handleError } from '../../../../shared';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisH, faFileExport, faSearchPlus } from '@fortawesome/free-solid-svg-icons';
import { useHistory } from 'react-router-dom';
import { DropdownButton } from '../../../blocks';
import { academicProgramsService } from '../../../../services';
import eventEmitter from "../../../../shared/eventEmitter";

export const ProgramRequestsTable = ({ tableData }) => {
    const getWidthStyle = width => ({ width, /*minWidth: width,*/ maxWidth: width });
    const history = useHistory();
    const [data, setData] = useState([]);
    const { setToast } = useToastState();

    useEffect(() => {
        if (tableData) setData(tableData);
    }, [tableData]);

    const dateFormatter = (cell, row) => {
        const date = new Date(row.lastUpdated);
        return (
            <Fragment>
                {format(date, 'M/d/yyyy')}
                <span className="d-block small">{format(date, 'h:mm aa')}</span>
                {row.status === 'Awaiting Institution' && (
                    <p className="text-italic text-warning nowrap">
                        Sent back to institution
                    </p>
                )}
            </Fragment>
        );
    };
    const programFormatter = (cell, row) => {
        return (
            <Fragment>
                <p className="mb-0">ID: {row.programID}</p>
                <p className="mb-0">{row.programName}</p>
                <p className="text-italic text-muted">{row.degreeLevel}</p>
            </Fragment>
        );
    };
    const cipFormatter = (cell, row) => {
        return (
            <Fragment>
                <p className="mb-0">{row.cipCode}</p>
                <p className="mb-0">{row.cipTitle}</p>
            </Fragment>
        );
    };

    const handleRowCheckboxChange = rowId => {
        setData(prevData =>
            prevData.map(row =>
                row.requestID === rowId ? { ...row, isSelected: !row.isSelected } : row
            )
        );
    };

    const checkboxFormatter = (cell, row) => {
        return (
            <Fragment>
                <input
                    type="checkbox"
                    checked={row.isSelected}
                    onChange={() => handleRowCheckboxChange(row.requestID)}
                />
            </Fragment>
        );
    };

    const headerCheckboxFormatter = (cell, row) => {
        return (
            <Fragment>
                <input
                    type="checkbox"
                    checked={row.isSelected}
                    onChange={e => {
                        const isChecked = e.target.checked;
                        setData(prevData =>
                            prevData.map(item => ({ ...item, isSelected: isChecked }))
                        );
                    }}
                />
            </Fragment>
        );
    };
    const actions = (cell, row) => {
        const idStart = 'PopoverView-' + row.requestID;
        return (
            <div className="d-flex">
                <Button
                    className="action-circle"
                    onClick={() => {
                        const requestId = row.requestID;
                        const location = {
                            pathname: UrlEnum.ADMIN_VIEW_ACADEMIC_PROGRAM_REQUESTS,
                            state: [
                                {
                                    requestID: requestId,
                                    rowData: row,
                                    otherRequests: tableData,
                                },
                            ],
                        };
                        history.push(location);
                    }}
                >
                    <UncontrolledPopover
                        target={idStart + '-view'}
                        trigger="hover"
                        placement="bottom"
                    >
                        <PopoverBody>View</PopoverBody>
                    </UncontrolledPopover>
                    <FontAwesomeIcon id={idStart + '-view'} icon={faSearchPlus} />
                </Button>
            </div>
        );
    };
    const options = {
        showTotal: true,
        firstPageText: 'First',
        prePageText: 'Previous',
        nextPageText: 'Next',
        lastPageText: 'Last',
        sizePerPage: 10,
        hideSizePerPage: true,
        alwaysShowAllBtns: true,
    };
    const columns = [
        {
            dataField: 'checkbox',
            text: '',
            sort: false,
            classes: 'nowrap',
            formatter: checkboxFormatter,
            headerFormatter: headerCheckboxFormatter,
            headerStyle: getWidthStyle(25),
        },
        {
            dataField: 'lastUpdated',
            text: 'Last Updated',
            sort: true,
            formatter: dateFormatter,
            headerStyle: getWidthStyle(150),
        },
        {
            dataField: 'institutionName',
            text: 'Institution',
            sort: true,
            headerStyle: getWidthStyle(150),
        },
        {
            dataField: 'programName',
            text: 'Program',
            sort: true,
            formatter: programFormatter,
            headerStyle: getWidthStyle(300),
        },
        {
            dataField: 'cipCode',
            text: 'CIP',
            sort: true,
            formatter: cipFormatter,
            headerStyle: getWidthStyle(100),
        },
        {
            dataField: 'description',
            text: 'Description',
            sort: true,
            headerStyle: getWidthStyle(150),
        },
        {
            dataField: 'actions',
            text: '',
            sort: false,
            classes: 'nowrap',
            formatter: actions,

            headerStyle: getWidthStyle(25),
        },
    ];

    // Hide the checkbox if approved or denied
    const excludedStatuses = ['3', '4'];
    const visibleColumns = columns.filter(column => {
        if (!tableData) return true;
        if (excludedStatuses.includes(tableData[0]?.statusId)) {
            return column.dataField !== 'checkbox';
        }
        return true;
    });

    const rowClasses = row => {
        return row.status === 'Awaiting Institution' ? 'bg-highlight' : '';
    };

    const getSelectedTableData = () => {
        return data.filter(x => x.isSelected);
    };

    /*const postData = {
        degreeLevel: x.degreeLevelId ? x.degreeLevelId : undefined,
        programId: x.programID ? x.programID : -1,
        locationStatusChanges: locationStatusChanges,
        formalName: x.programName ? x.programName : undefined,
        cipCode: x.cipCode ? x.cipCode : undefined,
        distanceEdApproved: {
            id: getDeliveryMode(x.deliveryMode),
        },
        comments: x.comments ? x.comments : undefined,
        creditRequirementMinimum: x.creditRequirementMinimum
          ? Number(x.creditRequirementMinimum)
          : undefined,
        creditRequirementMaximum: x.creditRequirementMaximum
          ? Number(x.creditRequirementMaximum)
          : undefined,
        institutionId: x.institution
          ? x.institution.value
          : undefined,
        credential: {
            ProgramURL: x.programURL ? x.programURL : '',
            Keywords: x.keywords ? x.keywords : '',
            ProgramDescription: x.description ? x.description : '',
            CredentialName: x.programName ? x.programName : undefined,
        },
    };*/

    const getDeliveryMode = deliveryMode => {
        if (deliveryMode === null || deliveryMode === undefined) return null;
        if (deliveryMode === 'On Campus & Online') {
            return 3;
        } else if (deliveryMode === 'On Campus Only') {
            return 1;
        } else {
            return 2;
        }
    };

    const getProgramStatusCode = programStatus => {
        const statusMap = {
            New: 0,
            Active: 1,
            Suspended: 3,
            Eliminated: 4,
            Merged: 5,
            Deleted: 6,
            Consolidated: 7,
            Paused: 8,
        };

        return statusMap[programStatus] ?? -1;
    };

    const handleBulkAction = async action => {
        const mappedData = getSelectedTableData().map(x => ({
            degreeLevel: x.degreeLevelId ? x.degreeLevelId : undefined,
            programId: x.programID ? x.programID : -1,
            locationStatusChanges: x.locations,
            formalName: x.programName ? x.programName : undefined,
            cipCode: x.cipCode ? x.cipCode : undefined,
            distanceEdApproved: {
                id: getDeliveryMode(x.deliveryMode),
            },
            distanceEdOnline: {
                id: getDeliveryMode(x.deliveryMode),
            },
            comments: x.comments ? x.comments : undefined,
            creditRequirementMinimum: x.creditRequirementMinimum
                ? Number(x.creditRequirementMinimum)
                : undefined,
            creditRequirementMaximum: x.creditRequirementMaximum
                ? Number(x.creditRequirementMaximum)
                : undefined,
            institutionId: x.institutionId ? x.institutionId : undefined,
            credential: {
                ProgramURL: x.programURL ? x.programURL : '',
                Keywords: x.keywords ? x.keywords : '',
                ProgramDescription: x.description ? x.description : '',
                CredentialName: x.programName ? x.programName : undefined,
            },
            programStatusId: getProgramStatusCode(x.programStatus),
            programStatus: x.programStatus,
            requestId: x.requestID,
        }));
        let statusId;
        if (action === 'Approve') {
            statusId = 3;
        } else if (action === 'Deny') {
            statusId = 4;
        } else {
            statusId = 2;
        }

        try {
            const response = await academicProgramsService.massProgramRequestStatusChange(
                statusId,
                mappedData
            );

            if (response === undefined) {
                return;
            }

            setData(prevData => prevData.map(item => ({ ...item, isSelected: false })));

            eventEmitter.emit('updateSARData');

            setToast({
                title: 'Success!',
                message: `Successfully processed ${mappedData.length} program request(s)`,
            });
        } catch (error) {
            handleError(error);
        }
    };

    const dropDownOptions = ['Move to under review', 'Approve', 'Deny'];

    return (
        <div className="card">
            <div
                className={`blue-header p-3 ${
                    getSelectedTableData().length === 0 ? 'd-none' : ''
                }`}
            >
                <div className="d-flex align-items-center">
                    <h2 className="mb-0 text-strong mr-3">
                        {getSelectedTableData().length} selected
                    </h2>
                    <DropdownButton
                        className="mr-2"
                        icon={faEllipsisH}                        
                        text="Bulk Actions"
                        options={dropDownOptions.map(label => {
                            return {
                                label: label,
                                onClick: () => handleBulkAction(label),
                            };
                        })}
                    />
                </div>
            </div>
            <div
                className="table-responsive hide-scrollbar"
                style={{ overflowX: 'hidden', width: '100%' }}
            >
                <BootstrapTable
                    keyField="requestID"
                    data={data}
                    columns={visibleColumns}
                    rowClasses={rowClasses}
                    striped
                    hover
                    pagination={paginationFactory(options)}
                    // defaultSorted={defaultSorted}
                />
            </div>
        </div>
    );
};
